import { ReactNode } from 'react';
import { ErrorBoundary as ErrorBoundaryBase } from 'react-error-boundary';

import { logError } from 'entities/modules/infra/logError';

import { useLang } from 'locale';

import { Button, Column } from 'components/Blocks';
import { AlertCircleIcon } from 'components/Blocks/Icons';

interface ErrorBoundaryProps {
  children: ReactNode;
}

export function ErrorBoundary({ children }: ErrorBoundaryProps) {
  const { t } = useLang();

  return (
    <ErrorBoundaryBase
      onError={(error, info) => logError({ error, reactInfo: info })}
      fallback={
        <div className="flex h-full items-center justify-center bg-primary p-2">
          <Column className="w-full max-w-96 rounded-lg bg-white p-4" alignItems="center">
            <AlertCircleIcon size={32} color="primary" />

            <h1 className="text-xl font-medium text-primary">{t('error-boundary.title')}</h1>

            <p className="text-center text-sm text-muted-foreground">
              {t('error-boundary.description')}
            </p>

            <Button
              onClick={() => {
                window.location.reload();
              }}
            >
              {t('error-boundary.button')}
            </Button>
          </Column>
        </div>
      }
    >
      {children}
    </ErrorBoundaryBase>
  );
}
